import React from "react";
import ProductListTable from "./ProductListTable";
import { Product } from "../../../types/modules/product.type";

type Props={
  products:Product[]
}

export default function ProductListWrapper({products}:Props) {
 

  return (
    <div className="p-4">
      <ProductListTable products={products} />
    </div>
  );
}
